import type { ActionItem } from './types';

export const baseActions: readonly ActionItem[] = [
  {
    key: 'jobEntry',
    title: '求人会員登録',
    description: '企業から直接スカウトが届くように！',
  },
  {
    key: 'agentService',
    title: 'エージェントサービス登録',
    description: '職務経歴書の書き方支援やキャリアの棚卸し、求人の選定など幅広くサポート',
  },
  {
    key: 'basicInfo',
    title: '基礎情報の登録',
    description: '企業スカウトが届きやすく！\nエージェントからの紹介求人の精度が高まる！',
  },
  {
    key: 'agentInterview',
    title: 'エージェントとの面談',
    description: '担当コンサルタントとの面談日程を設定！',
  },
];
